import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'edportal-signout-redirect-callback',
  template: '<div></div>',
})
export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.authService.completeLogout().then(() => {
      this.router.navigate(['/launch'], { replaceUrl: true });
    });
  }
}
